import { Component, Prop, h, Host } from '@stencil/core';
import state from '@ugc-store';
import { FontType, handleErrorMessage, showToast } from '@ugc-utils/utils';
import { getAbuseReportReason, getAbuseReportStatus } from '@ugc-api/report-abuse';
import { ReportAbuseType } from './interfaces';
import { Flag } from '../../icons';

@Component({
  tag: 'ugc-report-abuse',
  styleUrl: 'ugc-report-abuse.scss',
  shadow: false,
})
export class UgcReportAbuse {
  @Prop() type: ReportAbuseType;
  @Prop() variant: 'text' | 'button' = 'text';
  @Prop() referenceId: string;
  @Prop() fontType: FontType = FontType.large;

  // async get report abuse reason
  async getAbuseReasonList() {
    try {
      const reasonList = await getAbuseReportReason();
      state.reportAbuseReasonList = reasonList.map(item => ({
        value: `${item.id}`,
        name: 'report',
        content: item.content,
      }));
      state.reportAbuseModal = {
        type: this.type,
        referenceId: this.referenceId,
      };
      state.isShowReportAbuseModal = true;
    } catch (e) {
      handleErrorMessage(e);
    }
  }
  // async get report abuse reason
  async handleReportAbuse() {
    try {
      const { hasReported } = await getAbuseReportStatus(this.referenceId);
      if (hasReported) {
        showToast({
          type: 'warn',
          message: [this.getLanguage().IDS_UGC_REPORT_ABUSE_REPORTED || ''],
        });
        return;
      }
      this.getAbuseReasonList();
    } catch (e) {
      handleErrorMessage(e);
    }
  }

  getLanguage = () => {
    return this.type === ReportAbuseType.Review ? state.reviewStaticLanguage : state.qnaStaticLanguage;
  };

  render() {
    const { IDS_BTN_REPORT_ABUSE } = this.getLanguage();
    const isLargeType = this.fontType === FontType.large;
    if (this.variant === 'button')
      return (
        <Host>
          <ugc-button type="text" onClick={this.handleReportAbuse.bind(this)} customStyle={{ padding: '16px 0' }}>
            <span class="flex-row-start-center">
              <Flag />
              <span class="mlr-8 color-gray-700 fw-400 fs-16">{IDS_BTN_REPORT_ABUSE}</span>
            </span>
          </ugc-button>
        </Host>
      );
    return (
      <Host>
        <ugc-button type="text">
          <span
            class={`color-blue-dark pointer fw-400 ${isLargeType ? 'fs-16' : 'fs-14'}`}
            onClick={this.handleReportAbuse.bind(this)}
          >
            {IDS_BTN_REPORT_ABUSE}
          </span>
        </ugc-button>
      </Host>
    );
  }
}
